import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { navigationDrawerStyles } from "@insite/content-library/Components/NavigationDrawer";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import * as brandLogoStyles from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { headerSignInStyles } from "@insite/content-library/Widgets/Common/HeaderSignIn";
import { autocompleteBrandsStyles } from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import { autocompleteCategoriesStyles } from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import { autocompleteContentStyles } from "@insite/content-library/Widgets/Header/AutocompleteContent";
import { autocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import { headerLinkListStyles } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

baseTheme.breakpoints = {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: [0, 576, 768, 992, 1200],
    maxWidths: [540, 540, 732, 990, 1440],
};

headerSignInStyles.titleIcon!.color = "#0000FF";

headerSignInStyles.titleTypography = {
    css: css`
        margin-left: 0px;
        max-width: 150px;
        font-size: 14px;
        color: ${getColor("secondary.contrast")};
    `,
    ellipsis: true,
    transform: "capitalize",
    color: "#0000FF",
};

headerSignInStyles.titleClickable!.css = css`
    flex-direction: column;
`;

logoStyles.wrapper = {
    css: css`
        max-width: 300px;
        max-height: 100px;
        min-height: 100%;
        a:focus {
            outline: none;
        }
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                        flex-grow: 1;
                    `,
                    null,
                    null,
                ],
                "max",
            );
        }}
    `,
};

autocompleteCategoriesStyles.headerText!.color = "primary";
autocompleteCategoriesStyles.categoryItemText!.color = "secondary";
autocompleteCategoriesStyles.link!.color = "secondary";
autocompleteCategoriesStyles.focusedLink!.hoverMode = undefined;
autocompleteCategoriesStyles.link!.css = css`
    &:focus {
        outline: none;
    }
`;

autocompleteBrandsStyles.headerText!.color = "primary";
autocompleteBrandsStyles.focusedBrandItemText!.color = "secondary";
autocompleteBrandsStyles.brandItemText!.color = "secondary";
autocompleteBrandsStyles.link!.color = "secondary";

autocompleteContentStyles.headerText!.color = "primary";
autocompleteContentStyles.link!.color = "secondary";

autocompleteProductsStyles.headerText!.color = "primary";
autocompleteProductsStyles.titleLink!.typographyProps!.weight = "bold";
autocompleteProductsStyles.titleLink!.color = "secondary";
autocompleteProductsStyles.erpNumberText!.color = "secondary";

autocompleteProductsStyles.titleLink!.css = css`
    width: 270px;
    ${({ theme }) => {
        return breakpointMediaQueries(
            theme,
            [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ],
            "max",
        );
    }}
`;

autocompleteProductsStyles.erpNumberText!.css = css`
    width: 270px;
    text-align: left;
    margin: 5px 0 0 0;
    ${({ theme }) => {
        return breakpointMediaQueries(
            theme,
            [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ],
            "max",
        );
    }}
`;

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        display: none;
    `,
};
navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        &:first-child {
            margin-top: 0;
            padding-bottom: 10px;
            background: ${getColor("common.backgroundContrast")};
        }
        margin-top: 20px;
        &:last-child {
            margin-bottom: 5px;
            margin-top: 0;
        }
    `,
};

imageStyles.container = mergeToNew(imageStyles.container, {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    max-width: 100%;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
});

imageStyles.productLinkItem = mergeToNew(imageStyles.productLinkItem, {
    css: css`
        padding-right: 10px;
        justify-content: flex-end;
        text-align: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: center;
                `,
                css`
                    justify-content: center;
                `,
                null,
                null,
                null,
            ])}
    `,
    width: 12,
});

brandLogoStyles.logoStyles.container = mergeToNew(brandLogoStyles.logoStyles.container, {
    css: css`
        margin: 15px;
        width: 100%;
        max-width: 100%;
        & div[class^="LazyImageStyle"] {
            max-width: 300px;
            margin-left: -15px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin: 15px auto;
                    & div[class^="LazyImageStyle"] {
                        max-width: 100%;
                        margin-left: 0;
                    }
                `,
                css`
                    margin: 15px auto;
                `,
                null,
                null,
                null,
            ])}
    `,
});

brandLogoStyles.logoStyles.heading = mergeToNew(brandLogoStyles.logoStyles.heading, {
    css: css`
        font-size: 28px;
    `,
});
